import { LunaClient, apiContainer, LunaApiStreamsClient } from '@vlabs/api-bindings';

apiContainer.add('lunaClient', new LunaClient());
apiContainer.add('lunaStreamsClient', new LunaApiStreamsClient('/6/plugins/luna-streams'));
